import React, {useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import {changeUtmSource, useQuery} from "../../../../actions/actionCreators";

const mapStateToProps = state => ({...state});

/**
 * This HOC will extract the referral code from url and put it in the input.
 * @returns {JSX.Element}
 * @constructor
 * @param WrappedComponent
 */
const ExtractUtmSource = (WrappedComponent) => {

    const HOC = (props) => {

        const query = useQuery()

        useEffect(() => {

            const utmSourceUrl = query.get('utm_source');
            const utmSourceStorage = localStorage.getItem('utm_source');
            const utmSource = utmSourceUrl ?? utmSourceStorage
            changeUtmSource(utmSource)

        }, [])

        return <WrappedComponent {...props} />
    }

    return withRouter(connect(mapStateToProps)(HOC))
}
export default ExtractUtmSource;